(() => {
  angular
    .module('app.settings')
    .controller('DcmEditModalController', DcmEditModal);

  DcmEditModal.$inject = [
    '$q',
    '$interval',
    'close',
    'provider',
    'integration',
    'CountriesList',
    'allowedMetrics',
    'allowedCountries',
  ];

  function DcmEditModal(
    $q,
    $interval,
    close,
    provider,
    integration,
    CountriesList,
    allowedMetrics,
    allowedCountries,
  ) {
    const vm = this;
    vm.integration = integration;

    let originCountry = 'DK';
    let originMetrics = [];
    let originClients = [];
    let closeWithReload = false;

    vm.saveEnable = () => (
      vm.isAccountChanged() ||
      vm.isTitleChanged ||
      vm.isGranularityChanged ||
      vm.isApplicationTagChanged ||
      vm.isCountryChanged ||
      vm.isClientsChanged ||
      vm.isMetricsChanged ||
      vm.isVideoFunnelChanged
    ) && vm.isClientsAvailable;

    function initIntegration() {
      $(window).scrollTop(0);

      const {
        title,
        status,
        country,
        qualityMetrics,
        selectedAdvertisers,
        connectedUserEmail,
        googleProfileName,
        lastErrorDate,
        lastErrorMessage,
        lastIntegrationDateUTC,
        allowVideoFunnel,
      } = vm.integration;

      originCountry = country;
      originMetrics = qualityMetrics || [];
      originClients = selectedAdvertisers || [];
      vm.connectedUserEmail = connectedUserEmail;
      vm.title = title;
      vm.lastErrorDate = lastErrorDate;
      vm.lastErrorMessage = lastErrorMessage;
      vm.lastIntegrationDate = lastIntegrationDateUTC;
      vm.isIntegrationFailed = status === 'Failed';
      vm.isIntegrationInternalError = status === 'InternalError';
      vm.videoFunnelChecked = allowVideoFunnel;

      initGranularity();
      initCountries();
      initMetrics();

      vm.isProcessBusy = true;

      $q.all([
        loadAccounts(),
        loadClients(),
      ])
      .then(response => {
        vm.accounts = response[0].data;

        const selected = vm.accounts.find(item => item.profileName === googleProfileName);
        vm.selectedAccount = selected ? {
          ...selected,
          label: `${selected.name} (${selected.profileName})`,
        } : '';

        vm.clients = response[1].data;
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        vm.isProcessBusy = false;

        onLoadClients();
      });
    };
    initIntegration();


    /* ************************************************************* */
    /* *************************** Reconnect *********************** */
    /* ************************************************************* */
    vm.onReConnect = () => {
      vm.isProcessBusy = true;
      const { id: integrationId } = vm.integration;

      provider.reconnect({
        integrationId,
      }).then(({ data }) => {
        const dcm = window.open(data.url, '_blank');
        const interval = $interval(() => {
          if (!dcm.window) {
            $interval.cancel(interval);

            provider.fetchIntegration({
              integrationId: data.id
            })
            .then(response => {
              vm.integration = response.data;

              initIntegration();
            })
            .catch(error => {
              console.error(error);
            })
            .finally(() => {
              vm.isProcessBusy = false;
            });
          }
        }, 1000);
      });
    };



    /* ************************************************************* */
    /* *************************** Accounts ************************ */
    /* ************************************************************* */
    function loadAccounts() {
      const { id: integrationId } = vm.integration;
      return provider.fetchAccounts({ integrationId });
    }

    vm.onSelectAccount = account => {
      vm.selectedAccount = {
        ...account,
        label: `${account.name} (${account.profileName})`,
      };

      vm.isProcessBusy = true;
      loadClients()
        .then(({ data }) => {
          vm.clients = data;
          originClients = [];
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          vm.isProcessBusy = false;

          onLoadClients();
        });
    };

    vm.isAccountChanged = () => {
      if (!vm.selectedAccount) {
        return false;
      }

      const { googleProfileName } = vm.integration;
      return vm.selectedAccount.profileName !== googleProfileName;
    };


    /* ************************************************************* */
    /* *************************** Title   ************************* */
    /* ************************************************************* */
    vm.onTitleChange = () => {
      vm.isTitleChanged = vm.integration.title !== vm.title;
    }



    /* ************************************************************* */
    /* *************************** Clients ************************* */
    /* ************************************************************* */
    vm.clients = [];
    vm.clientsMenu = [];
    vm.isClientsAvailable = true;
    vm.search = '';

    function onLoadClients() {
      vm.clientsMenu = [{
        id: 'all',
        label: `All clients (${vm.clients.length})`,
      }, {
        id: 'selected',
        label: 'Selected clients only',
      }];

      vm.selectedClients = originClients && originClients.length === vm.clients.length ?
        vm.clientsMenu[0] : vm.clientsMenu[1];

      if (!vm.selectedClients || vm.selectedClients.length === 0) {
        vm.isClientsAvailable = false;
      }
    };

    function loadClients() {
      const {
        id: integrationId,
        googleAccountId,
        googleProfileId,
      } = vm.integration;

      return provider.fetchClients({
        integrationId,
        googleAccountId: vm.selectedAccount ? vm.selectedAccount.id : googleAccountId,
        googleProfileId: vm.selectedAccount ? vm.selectedAccount.profileId : googleProfileId,
      });
    };

    const onEditClients = () => {
      const selectedClients = vm.clients.filter(item => item.isSelected).map(item => item.name);
      vm.isClientsChanged = (originClients && !_.isEqual(selectedClients.sort(), originClients.sort())) ||
        (!originClients && selectedClients.length !== 0);
      vm.isClientsAvailable = selectedClients.length !== 0;
    };

    vm.onSelectAllClients = select => {
      angular.forEach(vm.clients, client => client.isSelected = !!select);
      onEditClients();
    };

    vm.onCheckClient = client => {
      client.isSelected = !client.isSelected;
      onEditClients();
    };

    vm.onSelectClients = item => {
      vm.selectedClients = item;
      if (item.id === 'all') {
        vm.onSelectAllClients(true);
      } else {
        onEditClients();
      }
    };

    vm.onShowSearch = () => vm.searchVisible = !vm.searchVisible;
    vm.onClearSearch = () => {
      vm.searchVisible = false;
      vm.search = '';
    };



    /* ************************************************************* */
    /* ************************* Granularity *********************** */
    /* ************************************************************* */
    function initGranularity() {
      const {
        trackingLevel,
        tagApplication,
      } = vm.integration;

      vm.granularity = [
        'Placement',
        'Site',
      ];
      vm.selectedGranularity = trackingLevel;
      vm.onSelectGranularity = granularity => {
        vm.selectedGranularity = granularity;
        vm.isGranularityChanged = granularity !== trackingLevel;
      };

      vm.applicationTag = [{
        key: 'Automatically',
        label: 'Measure all campaigns / ads',
      }, {
        key: 'Manually',
        label: 'Apply tag manually',
      }];
      vm.isApplicationTagManually = () => vm.selectedApplicationTag.key !== vm.applicationTag[0].key;
      vm.selectedApplicationTag = vm.applicationTag.find(item => item.key === tagApplication);
      vm.onSelectApplicationTag = tag => {
        vm.selectedApplicationTag = tag;
        vm.isApplicationTagChanged = vm.selectedApplicationTag.key !== tagApplication;
      };
    }



    /* ************************************************************* */
    /* *************************** Country ************************* */
    /* ************************************************************* */
    function initCountries() {
      vm.countries = CountriesList.filter(item => allowedCountries.includes(item.code));
      vm.selectedCountry = vm.countries.find(item => item.code === originCountry);
    };

    vm.onSelectCountry = country => {
      vm.selectedCountry = country;
      vm.isCountryChanged = country.code !== originCountry;
    };



    /* ************************************************************* */
    /* ************************** Video ADS ************************ */
    /* ************************************************************* */
    vm.onCheckVideoFunnel = () => {
      vm.videoFunnelChecked = !vm.videoFunnelChecked;

      const { allowVideoFunnel } = vm.integration;
      vm.isVideoFunnelChanged = vm.videoFunnelChecked !== !!allowVideoFunnel;
    };



    /* ************************************************************* */
    /* *************************** Quality ************************* */
    /* ************************************************************* */
    function initMetrics() {
      vm.metrics = allowedMetrics.map(item => ({
        ...item,
        checked: originMetrics && originMetrics.includes(item.key),
      }));
    }

    const onEditMetrics = () => {
      const selectedMetrics = vm.metrics.filter(item => item.checked).map(item => item.key);
      vm.isMetricsChanged = (originMetrics && !_.isEqual(selectedMetrics.sort(), originMetrics.sort())) ||
        (!originMetrics && selectedMetrics.length !== 0);
    };

    vm.onCheckMetric = metric => {
      const activeMetric = vm.metrics.find(item => item.name === metric.name);
      activeMetric.checked = !activeMetric.checked;
      onEditMetrics();
    };



    /* ************************************************************* */
    /* *************************** Actions ************************* */
    /* ************************************************************* */
    vm.onSave = () => {
      vm.isProcessBusy = true;

      const { id: integrationId } = vm.integration;

      provider.updateIntegration({
        integrationId,
        title: vm.title,
        country: vm.selectedCountry.code,
        googleAccountId: vm.selectedAccount.id,
        googleProfileId: vm.selectedAccount.profileId,
        googleAdvertiserIds: vm.selectedClients.id !== 'all' ?
          vm.clients.filter(item => item.isSelected).map(item => item.id) :
          vm.clients.map(item => item.id),
        trackingLevel: vm.isApplicationTagManually() ? undefined : vm.selectedGranularity,
        tagApplication: vm.selectedApplicationTag.key,
        qualityMetrics: vm.metrics.filter(item => item.checked).map(item => item.key),
        allowVideoFunnel: vm.videoFunnelChecked,
      })
      .then(() => {
        vm.isVideoFunnelChanged = false;
        vm.clientsAlreadyUsed = false;
        vm.isClientsAvailable = true;

        vm.onFinish();
      })
      .catch(error => {
        if (error.status === 400) {
          const message = /\[(.*?)\]/.exec(error.data.errorMessage);
          const ids = message ? message[1].split(',') : [];
          const clients = vm.clients.filter(({ id }) => ids.includes(id.toString()));

          vm.clientsAlreadyUsed = clients.map(({ name }) => name);
          vm.isClientsAvailable = false;
        } else {
          console.error(error);
        }
      })
      .finally(() => {
        vm.isProcessBusy = false;
      });
    };

    vm.onFinish = () => close(true, 0);
    vm.onClose = () => close(closeWithReload, 0);

    const collapsed = {
      connect: false,
      account: false,
      title: true,
      clients: false,
      granularity: true,
      country: true,
      video: true,
      quality: true,
    };
    vm.sectionCollapsed = section => collapsed[section];
    vm.onSectionCollapse = section => collapsed[section] = !collapsed[section];
  }
})();
